// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FYkM5","newExpiryDate":"styles_newExpiryDate__2ZyhZ","footer":"styles_footer__Pb3MH"};